import AlertMessageBox, {
  type AlertMessageBoxProps,
} from "~tailwindui/Basics/AlertMessageBox"
import Button, { type ButtonProps } from "~tailwindui/Basics/Button"
import ErrorIcon from "~tailwindui/Basics/ErrorIcon"

import Header, { HeaderProps } from "./Header"
import MultiSelect, { MultiSelectProps } from "./MultiSelect"
import PasswordInput, { type PasswordInputProps } from "./PasswordInput"
import Section, { type SectionProps } from "./Section"
import SingleSelect, { type SingleSelectProps } from "./SingleSelect"
import TextInput, { type TextInputProps } from "./TextInput"
import ToggleInput, { type ToggleInputProps } from "./ToggleInput"
import ValueDisplay, { type ValueDisplayProps } from "./ValueDisplay"

export default {
  AlertMessageBox,
  Button,
  ErrorIcon,
  Header,
  MultiSelect,
  PasswordInput,
  Section,
  SingleSelect,
  TextInput,
  ToggleInput,
  ValueDisplay,
}
export type {
  AlertMessageBoxProps,
  ButtonProps,
  HeaderProps,
  MultiSelectProps,
  PasswordInputProps,
  SectionProps,
  SingleSelectProps,
  TextInputProps,
  ToggleInputProps,
  ValueDisplayProps,
}
